import { useTranslation } from "react-i18next";

export interface ProductGridSkeletonProps {
  /** Cuántas tarjetas fantasma. Seis llenan dos filas en escritorio. */
  count?: number;
}

/**
 * Lo que se ve mientras el catálogo viaja.
 *
 * Son cajas con la MISMA proporción 3:4 que las tarjetas reales, no un
 * spinner centrado: cuando llegan los datos, nada se mueve de sitio.
 *
 * El bloque entero es una sola región `aria-busy` con un texto para el
 * lector de pantalla; seis cajas vacías no le dicen nada a nadie.
 */
export function ProductGridSkeleton({ count = 6 }: ProductGridSkeletonProps) {
  const { t } = useTranslation();

  return (
    <div role="status" aria-busy="true" className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      <span className="sr-only">{t("Cargando el catálogo…")}</span>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          aria-hidden="true"
          className="animate-pulse overflow-hidden rounded-ds-xl border border-ds-border bg-white motion-reduce:animate-none"
        >
          <div className="aspect-[3/4] w-full bg-ds-mist/60" />
        </div>
      ))}
    </div>
  );
}
